var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('div',{staticClass:"tag",class:[`tag_size-${_vm.size}`, `tag_color-${_vm.color}`],style:(_vm.styleRoot)},[_c('p',{staticClass:"tag__title"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"tag__caption"},[_vm._v(_vm._s(_vm.caption))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }